import { AssignmentStatus } from '../types/assignment-status';
import { AssignmentStatusDTO } from '../types/dto';

/**
 * Maps API assignment status DTO to internal AssignmentStatus enum.
 * Handles the conversion from wire format to application domain model.
 */
export const mapAssignmentStatusFromDTO = (status: AssignmentStatusDTO): AssignmentStatus => {
  switch (status) {
    case AssignmentStatusDTO.CONFIRMED:
      return AssignmentStatus.Confirmed;
    case AssignmentStatusDTO.UNCONFIRMED:
      return AssignmentStatus.Unconfirmed;
    case AssignmentStatusDTO.DRAFT:
      return AssignmentStatus.Draft;

    default:
      return AssignmentStatus.Confirmed;
  }
};

/**
 * Maps internal AssignmentStatus enum to API assignment status DTO.
 * Handles the conversion from application domain model to wire format.
 */
export const mapAssignmentStatusToDTO = (status: AssignmentStatus): AssignmentStatusDTO => {
  switch (status) {
    case AssignmentStatus.Confirmed:
      return AssignmentStatusDTO.CONFIRMED;
    case AssignmentStatus.Unconfirmed:
      return AssignmentStatusDTO.UNCONFIRMED;
    case AssignmentStatus.Draft:
      return AssignmentStatusDTO.DRAFT;
    default:
      return AssignmentStatusDTO.CONFIRMED;
  }
};
